<div class="pg-overlay" *ngIf="show() && gate() as g">
  <div class="pg-card">
    <div class="pg-icon">
      <mat-icon>lock</mat-icon>
    </div>
    <div class="pg-kicker">{{ 'planGate.kicker' | translate }}</div>
    <h2 class="pg-title">{{ g.titleKey | translate }}</h2>
    <p class="pg-desc">{{ g.descKey | translate }}</p>
    <button class="pg-cta" (click)="goPricing()">
      {{ 'planGate.upgradeCta' | translate }}
    </button>
    <div class="pg-trial">{{ 'planGate.trialNote' | translate }}</div>
  </div>
</div>
